import generateLocatorsMap from '../../utils/generateLocatorsMap';

const base = 'dropDown';

const locatorsMap = {
  list: 'list',
  resetButton: 'resetButton',
} as const;

export default generateLocatorsMap(base, locatorsMap);
